import React from "react";

function HeartFillIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 20 18"
    >
      <path
        fill="currentColor"
        d="M14.111 0C17.633 0 20 3.353 20 6.48 20 12.814 10.178 18 10 18 9.822 18 0 12.814 0 6.48 0 3.352 2.367 0 5.889 0 7.91 0 9.233 1.024 10 1.924 10.767 1.024 12.089 0 14.111 0z"
      ></path>
    </svg>
  );
}

export default HeartFillIcon;
